import ModalWithAges from './ModalWithAges';

export default ModalWithAges;
